// Lightweight sound effects using Web Audio API - no audio files needed
let audioCtx = null;

function getContext() {
  if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtx;
}

function playTone(frequency, duration, type = 'sine', volume = 0.15) {
  try {
    const ctx = getContext();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = type;
    osc.frequency.value = frequency;
    gain.gain.value = volume;
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (e) {
    // Audio not supported or blocked
  }
}

export function playSuccess() {
  playTone(523, 0.1); // C5
  setTimeout(() => playTone(659, 0.1), 80); // E5
  setTimeout(() => playTone(784, 0.15), 160); // G5
}

export function playError() {
  playTone(330, 0.15, 'square', 0.1); // E4
  setTimeout(() => playTone(262, 0.2, 'square', 0.1), 120); // C4
}

export function playNotification() {
  playTone(880, 0.08); // A5
  setTimeout(() => playTone(1047, 0.12), 100); // C6
}

export function playClick() {
  playTone(1200, 0.03, 'sine', 0.08);
}

export function playLogin() {
  playTone(392, 0.1); // G4
  setTimeout(() => playTone(523, 0.1), 100); // C5
  setTimeout(() => playTone(659, 0.12), 200); // E5
  setTimeout(() => playTone(784, 0.2), 300); // G5
}

export function playDelete() {
  playTone(440, 0.1, 'triangle', 0.1);
  setTimeout(() => playTone(330, 0.15, 'triangle', 0.08), 80);
}
